import { NgModuleFactory, Type } from '@angular/core';

// This will create a dedicated JS bundle for lazy module
export const lazyWidgets: { path: string, loadChildren: () => Promise<NgModuleFactory<any> | Type<any>> }[] = [
  {
    path: 'personal-info-verify',
    loadChildren: () => import('../../views/pages/profile/components/verify/personal/verify-personal.module')
    .then(m => m.VerifyPersonalModule)
  },
  {
    path: 'address-info-verify',
    loadChildren: () => import('../../views/pages/profile/components/verify/address/verify-address.module')
    .then(m => m.VerifyAddressModule)
  },
  {
    path: 'photo-verify',
    loadChildren: () => import('../../views/pages/profile/components/verify/photo/verify-photo.module')
    .then(m => m.VerifyPhotoModule)
  }
];

// This function will work as a factory for injecting lazy widget array in the main module
export function lazyArrayToObj() {
  const result = {};
  for (const w of lazyWidgets) {
    result[w.path] = w.loadChildren;
  }
  return result;
}